<template>
    <v-dialog v-model="showDialog">
        <v-card>
            <v-card-title style="background-color: #00BFA5; margin-bottom: 20px; position: relative;" class="white--text">
                View Ledger: &nbsp;&nbsp; <v-chip dense style="font-weight: 600;">
                    {{ currentView.CNTRL_N }}
                </v-chip> &nbsp; - {{ currentView.hosp_name }}
                <v-btn
                    text
                    icon
                    style="position: absolute; right: 13px;"
                    @click="showDialog=false"
                >
                    <v-icon class="white--text">
                        {{ mdiClose }}
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            dense
                            :items="viewLedgerData && viewLedgerData.data ? viewLedgerData.data : []"
                            :headers="headers"
                            :search="search"
                        >
                            <template #top>
                                <v-text-field
                                    v-model="searchQuery"
                                    label="Search"
                                    hide-details
                                    dense
                                    color="teal"
                                    style="margin-bottom: 5px;"
                                    clearable
                                    :append-icon="mdiMagnify"
                                    @keyup.enter="search = searchQuery"
                                    @click:append="search = searchQuery"
                                    @click:clear="search = ''"
                                />
                            </template>
                            <template #[`item.OPAN_N`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.OPAN_N }}</span>
                            </template>
                            <template #[`item.LAST_M`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.LAST_M }}</span>
                            </template>
                            <template #[`item.APPR_D`]="{ item }">
                                <span style="text-wrap: nowrap">{{ formatDate(item.APPR_D) }}</span>
                            </template>
                            <template #[`item.VALI_D`]="{ item }">
                                <span style="text-wrap: nowrap">{{ formatDate(item.VALI_D) }}</span>
                            </template>
                            <template #[`item.DOCT_S`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.DOCT_S }}</span>
                            </template>
                            <template #[`item.hosp_name`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.hosp_name }}</span>
                            </template>
                            <template #[`item.ACCT_M`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.ACCT_M }}</span>
                            </template>
                            <template #[`item.ISSU_N`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.ISSU_N }}</span>
                            </template>
                            <template #[`item.MALA`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.MALA }}</span>
                            </template>
                            <template #[`item.REMA`]="{ item }">
                                <span style="text-wrap: nowrap">{{ item.REMA }}</span>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import {
    mdiClose,
    mdiMagnify
} from '@mdi/js'
import { moment } from '../../../utils/date-shim'

export default {
    props: ['show', 'currentView'],
    data: () => ({
        mdiClose,
        mdiMagnify,
        searchQuery: null,
        search: null,
        headers: [
            { text: 'Approval No.', value: 'OPAN_N' },
            { text: 'Account Name', value: 'ACCT_M' },
            { text: 'Member No.', value: 'MEMB_N' },
            { text: 'Name', value: 'LAST_M' },
            { text: 'Consultation Date', value: 'APPR_D' },
            { text: 'Valid Until', value: 'VALI_D' },
            { text: 'Hospital/Clinic Name', value: 'hosp_name' },
            { text: 'Doctor\'s Name', value: 'DOCT_S' },
            { text: 'Max Allowable Limit', value: 'MALA' },
            { text: 'Remarks', value: 'REMA' },
            { text: 'Issue By', value: 'ISSU_N' },
            { text: 'Issued Time', value: 'STIME' }
        ]
    }),
    computed: {
        ...mapGetters(['viewLedgerData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        searchQuery(newVal) {
            if (newVal === '' || newVal === null || newVal === undefined)
                this.search = ''
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('MMM D, YYYY')
        }
    }
}
</script>
